//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data: function data() {
        return {
            headers: [{ title: 'Period', filter: 'datePeriod' }, { title: 'Transaction Date', filter: 'dateFull' }, { title: 'Next Run Date', filter: 'dateFull' }, { title: 'End Date', filter: 'dateFull' }],
            fields: ['period', 'transaction_date', 'next_run_date', 'ends_at'],
            items: [],
            loading: true
        };
    },
    mounted: function mounted() {

        var $el = this;

        Event.$on('add-recurring-entry', function () {
            Event.$emit('recurring-journal-entry');
        });

        Event.$on('update-recurring-entry', function (item) {
            Event.$emit('update-recurring-journal-entry', item);
        });

        Event.$on('remove-recurring-entry', function (item, idx) {
            Event.$emit('confirm-delete', item, '/prototype/accounting/general-ledger/recurring-journal-entry/remove', 'delete-entry', 'Are you sure you want to delete this journal entry?', 'Delete');
        });

        Event.$on('delete-recurring-entry', function (item) {
            var $idx = $el.items.findIndex(function (i) {
                return i.id === item.id;
            });
            $el.items.splice($idx, 1);
        });

        Event.$on('view-recurring-entry', function (item, idx) {
            Event.$emit('show-flyout', 'Journal Entry Details', '/prototype/accounting/general-ledger/journal-entry/view', 'journal-entry-details', item);
        });

        Event.$on('refresh-recurring-journal-entries', function () {
            $el.load();
        });
    },


    methods: {
        load: function load() {
            var $el = this;
            $el.items = [];
            axios.post('/prototype/accounting/general-ledger/recurring-journal-entry/fetch').then(function (response) {
                $el.items = response.data;
                $el.items.map(function (item) {
                    item['count'] = item.entries.length;
                    item['amount'] = 0.00;
                    item.entries.map(function (entry) {
                        item['amount'] += Number.parseFloat(entry.credit);
                    });
                });
                $el.loading = false;
            });
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/general-ledger/journal-entry/RecurringJournalEntryList.vue
// module id = qlG3
// module chunks = 0 1